    document.addEventListener('DOMContentLoaded', function () {
      document.body.style.overflow = 'auto';

      const slider = document.querySelector('.addon-slider');
      const prevButton = document.querySelector('.slider-prev');
      const nextButton = document.querySelector('.slider-next');
      
      if (!slider || !prevButton || !nextButton) return;

      let currentIndex = 0;
      let cardWidth;
      let margin = 10;

      function calculateCardsPerView() {
        const containerWidth = document.querySelector('.addon-slider-container').offsetWidth;
        const card = slider.querySelector('.addon-product-card');
        if (!card) return;
        
        const cardsPerView = 3; 
        const totalMargin = margin * (cardsPerView - 1);
        cardWidth = (containerWidth - totalMargin) / cardsPerView;
        
        document.querySelectorAll('.addon-product-card').forEach(card => {
          card.style.width = `${cardWidth}px`;
          card.style.marginRight = `${margin}px`;
          card.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        });
        
        slider.style.width = `calc(${cardWidth * slider.children.length}px + ${margin * (slider.children.length - 1)}px)`;
      }

      function updateSlider() {
        const slideAmount = (cardWidth + margin) * currentIndex;
        const containerWidth = document.querySelector('.addon-slider-container').offsetWidth;
        const maxTranslate = slider.scrollWidth - containerWidth;
        
        currentIndex = Math.min(currentIndex, Math.ceil(maxTranslate / (cardWidth + margin)));
        slider.style.transform = `translateX(-${Math.min(slideAmount, maxTranslate)}px)`;
        
        const activeDotIndex = Math.floor(currentIndex / 2);
        document.querySelectorAll('.slider-dot').forEach((dot, index) => {
          dot.classList.toggle('active', index === activeDotIndex);
        });
      }

      calculateCardsPerView();
      updateSlider();

      prevButton.addEventListener('click', (e) => {
        e.preventDefault();
        const step = 2; 
        currentIndex = Math.max(currentIndex - step, 0);
        updateSlider();
      });

      nextButton.addEventListener('click', (e) => {
        e.preventDefault();
        const step = 2;
        const cardsPerView = 3;
        const maxIndex = slider.children.length - cardsPerView;
        currentIndex = Math.min(currentIndex + step, maxIndex);
        updateSlider();
      });

      function createDots() {
        const cardsPerSlide = 2;
        const cardsPerView = 3;
        const totalDots = Math.ceil((slider.children.length - cardsPerView) / cardsPerSlide) + 1;
        
        dotsContainer.innerHTML = '';
        
        for (let i = 0; i < totalDots; i++) {
          const dot = document.createElement('button');
          dot.className = 'slider-dot' + (i === 0 ? ' active' : '');
          dot.addEventListener('click', () => {
            currentIndex = i * cardsPerSlide;
            updateSlider();
          });
          dotsContainer.appendChild(dot);
        }
      }

      const dotsContainer = document.createElement('div');
      dotsContainer.className = 'slider-dots';
      document.querySelector('.addon-slider-container').appendChild(dotsContainer);
      createDots();

      const resizeObserver = new ResizeObserver(entries => {
        calculateCardsPerView();
        createDots();
        updateSlider();
      });

      resizeObserver.observe(document.querySelector('.addon-slider-container'));

      window.addEventListener('resize', () => {
        calculateCardsPerView();
        createDots();
        updateSlider();
      });

      const quantityInputs = document.querySelectorAll('.addon-quantity .quantity__input');
      quantityInputs.forEach(input => {
        const minusButton = input.previousElementSibling;
        const plusButton = input.nextElementSibling;

        minusButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          input.value = Math.max(1, input.value - 1);
          updateAddonQuantity(input);
        });

        plusButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          input.value = parseInt(input.value) + 1;
          updateAddonQuantity(input);
        });

        input.addEventListener('change', function() {
          this.value = Math.max(1, this.value);
          updateAddonQuantity(this);
        });
      });

      const productCards = document.querySelectorAll('.addon-product-card');
      productCards.forEach(card => {
        const checkbox = card.querySelector('.addon-checkbox');
        const selectButton = card.querySelector('.select-button');
        const minusButton = card.querySelector('.quantity__button[name="minus"]');
        const plusButton = card.querySelector('.quantity__button[name="plus"]');
        const quantityInput = card.querySelector('.quantity__input');

        selectButton.addEventListener('click', (e) => {
          e.stopPropagation(); 
          checkbox.checked = !checkbox.checked;
          checkbox.dispatchEvent(new Event('change'));
          updateAddonQuantity(quantityInput); 
          if (checkbox.checked) {
            selectButton.style.display = 'none';
            minusButton.style.display = 'inline-block';
            plusButton.style.display = 'inline-block';
            quantityInput.style.display = 'inline-block';
          } else {
            selectButton.style.display = 'inline-block';
            minusButton.style.display = 'none';
            plusButton.style.display = 'none';
            quantityInput.style.display = 'none';
          }
        });
        card.addEventListener('click', (e) => {
          if (e.target.closest('.addon-quantity')) return;
          selectButton.click(); 
        });
      });
      const checkboxes = document.querySelectorAll('.addon-checkbox');
      checkboxes.forEach(checkbox => {
        const checkmark = checkbox.nextElementSibling?.querySelector('.checkmark');
        const quantityInput = checkbox.closest('.addon-product-card')?.querySelector('.quantity__input');
        
        checkbox.addEventListener('change', function() {
          if (checkmark) {
            checkmark.classList.toggle('checked', this.checked);
          }
          const addonId = this.dataset.addonId;
          const quantity = parseInt(quantityInput?.value || 1);
          toggleMainAddon(addonId, this.checked ? quantity : 0);
        });
      });
      function updateAddonQuantity(input) {
        const checkbox = input.closest('.addon-product-card').querySelector('.addon-checkbox');
        if (checkbox?.checked) {
          const addonId = checkbox.dataset.addonId;
          toggleMainAddon(addonId, parseInt(input.value));
        }
      }

      function toggleMainAddon(addonId, quantity = 1) {
        const index = window.selectedAddons.findIndex(item => item.id === addonId);
        if (index > -1) {
          if (quantity > 0) {
            window.selectedAddons[index].quantity = quantity;
          } else {
            window.selectedAddons.splice(index, 1);
          }
        } else if (quantity > 0) {
          window.selectedAddons.push({ id: addonId, quantity: quantity });
        }
      }
      window.selectedAddons = [];
      const addToCartButton = document.querySelector('[name="add"]');

      if (addToCartButton) {
        addToCartButton.addEventListener('click', function(e) {
          e.preventDefault();
          
          const variantInput = document.querySelector('[name="id"]');
          if (!variantInput) return;
          
          const items = [{
            id: variantInput.value,
            quantity: parseInt(document.querySelector('[name="quantity"]')?.value || 1)
          }];
          
          const allAddons = [...(window.selectedAddons || []), ...(window.selectedExtraAddons || [])];
          allAddons.forEach(addon => {
            items.push({
              id: addon.id,
              quantity: addon.quantity
            });
          });

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ items })
          })
          .then(response => {
            if (!response.ok) {
              return response.json().then(err => Promise.reject(err));
            }
            return response.json();
          })
          .then(data => {
            // window.location.href = '/cart';
          })
          .catch(error => {
            console.error('Error:', error);
            alert(error.description || 'Failed to add items to cart');
          })
          .finally(() => {
            this.disabled = false;
          });
          
          this.disabled = true;
        });
      }

      let isDragging = false;
      let startPosX = 0;
      let currentTranslate = 0;
      let prevTranslate = 0;
      let animationID;

      if (window.innerWidth < 768) {
        slider.style.cursor = 'grab';

        slider.addEventListener('touchstart', touchStart);
        slider.addEventListener('touchmove', touchMove);
        slider.addEventListener('touchend', touchEnd);
        slider.addEventListener('touchcancel', touchEnd);
      }

      function touchStart(e) {
        if (window.innerWidth >= 768) return;
        
        isDragging = true;
        startPosX = getPositionX(e);
        prevTranslate = currentTranslate;
        slider.style.transition = 'none';
        slider.style.cursor = 'grabbing';
        cancelAnimationFrame(animationID);
      }

      function touchMove(e) {
        if (!isDragging || window.innerWidth >= 768) return;
        
        const currentPosition = getPositionX(e);
        const diff = currentPosition - startPosX;
        currentTranslate = prevTranslate - diff;
        
        const maxTranslate = slider.scrollWidth - slider.parentElement.offsetWidth;
        currentTranslate = Math.max(0, Math.min(currentTranslate, maxTranslate));
        
        slider.style.transform = `translateX(-${currentTranslate}px)`;
      }

      function touchEnd() {
        if (window.innerWidth >= 768) return;
        
        isDragging = false;
        slider.style.cursor = 'grab';
        slider.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';

        const movedBy = currentTranslate - prevTranslate;
        const velocity = movedBy / 100;
        
        let finalTranslate = currentTranslate + (velocity * 50);
        finalTranslate = Math.max(0, Math.min(finalTranslate, slider.scrollWidth - slider.parentElement.offsetWidth));

        const cardsPerSlide = 2;
        const cardsPerView = 3;
        currentIndex = Math.round(finalTranslate / (cardWidth + margin));
        currentIndex = Math.min(currentIndex, slider.children.length - cardsPerView);
        
        currentTranslate = currentIndex * (cardWidth + margin);
        slider.style.transform = `translateX(-${currentTranslate}px)`;
        updateSlider();
      }

      function getPositionX(e) {
        return e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
      }

      function updateDots() {
        const dots = document.querySelectorAll('.slider-dot');
        dots.forEach((dot, index) => {
          dot.classList.toggle('active', index === currentIndex);
        });
      }
      
    });
